import { render, staticRenderFns } from "./permissionPage.vue?vue&type=template&id=3caf5a15&scoped=true&"
import script from "./permissionPage.vue?vue&type=script&lang=js&"
export * from "./permissionPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3caf5a15",
  null
  
)

export default component.exports